import { BrandMark } from '@/components/shared/BrandMark';
import { Button } from '@/components/shared/Button';
import { Panel } from '@/components/shared/Panel';
import { useAuth } from '@/hooks/useAuth';

export function PendingApprovalPage(): JSX.Element {
  const { logout, profile } = useAuth();

  return (
    <div className="auth-page">
      <div className="auth-page__backdrop" />
      <Panel
        title="Pending Approval"
        description="Your Discord login worked, but your guild profile is still pending review."
      >
        <div className="auth-card">
          <BrandMark />
          <p className="auth-card__message">
            {profile?.displayName ?? 'Guild member'}, an officer or admin needs to approve your account before you can
            access active mass signups.
          </p>
          <Button variant="secondary" onClick={logout}>
            Sign Out
          </Button>
        </div>
      </Panel>
    </div>
  );
}
